import { render, staticRenderFns } from "./ChangeSecretQuestionModal.vue?vue&type=template&id=3ed216ac&scoped=true&"
import script from "./ChangeSecretQuestionModal.vue?vue&type=script&lang=js&"
export * from "./ChangeSecretQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSecretQuestionModal.vue?vue&type=style&index=0&id=3ed216ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed216ac",
  null
  
)

export default component.exports